export const CORDOVA_START_SUBSCRIPTION = "cordova-start-subscription"
export const CORDOVA_CLOSE_SUBSCRIPTION = "cordova-close-subscription"